const OPERATOR_STATISTICS = {
  OPERATOR_STATS_HEADER_TITLE: 'آمار اپراتورها',
  OPERATOR_STATS_HEADER_DESC:
    'شما می‌توانید جزئیات زمان‌ فعالیت (اولین و آخرین آنلاین) و تعداد مکالمات اپراتور را در وضعیت‌های مختلف ( قبول شده، پایان یافته و ...) با انتخاب بازه زمانی مورد نظر خود بررسی و خروجی آمار نیز دریافت نمایید.',
  OPERATOR_STATS_MAIN_TITLE: 'زمان های كاری اپراتورها',
  OPERATOR_STATS_OPERATOR_STATS_TITLE: 'آمار مكالمات',
  OPERATOR_STATS_ACCEPTED_CONVS: 'مكالمه قبول شده : ',
  OPERATOR_STATS_FIRST_ONLINE: 'اولين آنلاين :',
  OPERATOR_STATS_LAST_ONLINE: 'آخرين آنلاين : ',
  OPERATOR_STATS_ENDED_CONVS: 'مکالمات پایان یافته : ',
  OPERATOR_STATS_CONV_PREFIX: 'مکالمه',
  OPERATOR_STATS_ACTIVE_TIME: 'زمان های فعاليت',
  OPERATOR_STATS_CONVS_STATS: 'آمار مكالمات',
  OPERATOR_STATS_TOTAL_HOUR_LABEL: 'كل زمان آنلاين اپراتور',
  OPERATOR_STATS_TOTAL_HOUR_PREFIX: 'ساعت',
  OPERATOR_STATS_CHART_TAB_CONVS_STATS: 'آمار مكالمات',
  OPERATOR_STATS_CHART_TAB_ACTIVE_TIME: 'زمان های فعاليت',
  OPERATOR_STATS_CHART_LEGEND_ACCEPTED_CONVS: 'مكالمه قبول شده : ',
  OPERATOR_STATS_CHART_LEGEND_ENDED_CONVS: 'مکالمات بسته شده : ',
  OPERATOR_STATS_CHART_LEGEND_UNANSWERED_CONVS: 'مکالمات بدون پاسخ :',
  OPERATOR_STATS_CHART_LEGEND_DENIED_CONVS: 'مکالمات رد شده :',
  OPERATOR_STATS_DOWNLOAD_BTN_TEXT: 'دریافت',
};

export default OPERATOR_STATISTICS;
